import { render, staticRenderFns } from "./PhoneInternational.vue?vue&type=template&id=56048580&"
import script from "./PhoneInternational.vue?vue&type=script&lang=js&"
export * from "./PhoneInternational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports